
const nav = document.getElementById('nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('scrolled', window.scrollY > 60);
}, { passive: true });

const hamburger  = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobileMenu');

hamburger.addEventListener('click', () => {
  hamburger.classList.toggle('open');
  mobileMenu.classList.toggle('open');
  document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
});

function closeMenu() {
  hamburger.classList.remove('open');
  mobileMenu.classList.remove('open');
  document.body.style.overflow = '';
}
window.closeMenu = closeMenu;

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach((el, i) => {
  el.style.transitionDelay = `${(i % 4) * 0.1}s`;
  revealObserver.observe(el);
});

const imgWrap = document.getElementById('imgWrap');
const flipBtn = document.getElementById('flipBtn');

if (flipBtn && imgWrap) {
  flipBtn.addEventListener('click', () => {
    imgWrap.classList.toggle('flipped');
    flipBtn.classList.toggle('active');
    const isFlipped = imgWrap.classList.contains('flipped');
    flipBtn.querySelector('span:last-child').textContent = isFlipped ? 'Ver frente' : 'Ver reverso';
  });
}

const lightbox      = document.getElementById('lightbox');
const lightboxImg   = document.getElementById('lightboxImg');
const lightboxClose = document.getElementById('lightboxClose');

function openLightbox(src, alt) {
  lightboxImg.src = src;
  lightboxImg.alt = alt || '';
  lightbox.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeLightbox() {
  lightbox.classList.remove('open');
  document.body.style.overflow = '';
  setTimeout(() => { lightboxImg.src = ''; }, 300);
}

const heroBottle = document.getElementById('heroBottle');
if (heroBottle) {
  heroBottle.addEventListener('click', () => openLightbox(heroBottle.src, heroBottle.alt));
}

['zoomFront','zoomBack'].forEach(id => {
  const el = document.getElementById(id);
  if (el) el.addEventListener('click', () => openLightbox(el.src, el.alt));
});

lightboxClose.addEventListener('click', closeLightbox);
lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeLightbox();
    if (typeof window.closeCart === 'function') window.closeCart();
  }
});

const enzoObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      enzoObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.3 });

document.querySelectorAll('.enzo__word').forEach(w => enzoObserver.observe(w));

const testiObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      testiObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.testi-card').forEach(c => testiObserver.observe(c));

const badgeNumber = document.querySelector('.garantia__badge-number');
const badgeWrap   = document.querySelector('.garantia__badge');

if (badgeNumber && badgeWrap) {
  const target = 6;
  badgeNumber.textContent = '0';
  let animated = false;

  new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting || animated) return;
    animated = true;

    setTimeout(() => {
      let start = null;
      const duration = 480;

      function step(ts) {
        if (start === null) start = ts;
        const progress = Math.min((ts - start) / duration, 1);
        badgeNumber.textContent = Math.floor(progress * target);
        if (progress < 1) requestAnimationFrame(step);
        else badgeNumber.textContent = target;
      }
      requestAnimationFrame(step);

    }, 500);
  }, { threshold: 0.2 }).observe(badgeWrap);
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    const offset = nav.offsetHeight + 8;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  });
});

window.addEventListener('load', () => {
  if (!location.hash) return;
  let target = null;
  try { target = document.querySelector(location.hash); } catch (e) { return; }
  if (!target) return;
  const offset = nav.offsetHeight + 8;
  const top = target.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior: 'instant' });
  history.replaceState(null, '', location.pathname + location.search);
});

const faqMan = document.getElementById('faqMan');
if (faqMan) {
  new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) faqMan.classList.add('visible');
  }, { threshold: 0.15 }).observe(faqMan);
}

const faqItems = document.querySelectorAll('.faq__item');

function closeFaq(item) {
  const answer = item.querySelector('.faq__answer');
  answer.style.height = answer.scrollHeight + 'px';
  requestAnimationFrame(() => {
    answer.style.height = '0px';
    answer.style.opacity = '0';
  });
  answer.addEventListener('transitionend', () => {
    item.removeAttribute('open');
    answer.style.height = '';
    answer.style.opacity = '';
  }, { once: true });
}

function openFaq(item) {
  item.setAttribute('open', '');
  const answer = item.querySelector('.faq__answer');
  const targetH = answer.scrollHeight + 'px';
  answer.style.height = '0px';
  answer.style.opacity = '0';
  requestAnimationFrame(() => requestAnimationFrame(() => {
    answer.style.height = targetH;
    answer.style.opacity = '1';
  }));
  answer.addEventListener('transitionend', (e) => {
    if (e.propertyName === 'height') answer.style.height = 'auto';
  }, { once: true });
}

faqItems.forEach(item => {
  item.querySelector('.faq__question').addEventListener('click', (e) => {
    e.preventDefault();
    const isOpen = item.hasAttribute('open');
    faqItems.forEach(other => { if (other !== item && other.hasAttribute('open')) closeFaq(other); });
    isOpen ? closeFaq(item) : openFaq(item);
  });
});
